// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".velocity-vision-velocityContainer--3rO9DvPAYcxlKqhsuGPUEr{padding:10px 10px 0 10px}", "",{"version":3,"sources":["webpack://src/components/velocityVision/VelocityVision/velocityVision.module.scss"],"names":[],"mappings":"AAAA,2DACC,wBAAA","sourcesContent":[".velocityContainer {\r\n\tpadding: 10px 10px 0 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"velocityContainer": "velocity-vision-velocityContainer--3rO9DvPAYcxlKqhsuGPUEr"
};
export default ___CSS_LOADER_EXPORT___;
